// 创建人：寒立
// 功能：封装的cookies方法

import Cookies from 'js-cookie'


export function getCookie(e) {
  return Cookies.get(e)
}

export function setCookie(name,e) {
  return Cookies.set(name, e)
}

export function removeCookie(e) {
  return Cookies.remove(e)
}
